<div class="container">
  <h1 class="text-center bg-warning">Gender Count Report</h1>
  <strong> (N: New Admission F: Followup's )</strong>
  <div class="row">
    <mat-form-field appearance="outline" class="col-md-4">
      <mat-label>Enter a date range</mat-label>
      <mat-date-range-input [rangePicker]="picker">
        <input matStartDate [(ngModel)]="startDate" placeholder="Start date">
        <input matEndDate [(ngModel)]="endDate" placeholder="End date" (dateChange)="onEndDateChanged()">
      </mat-date-range-input>
      <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
      <mat-date-range-picker #picker></mat-date-range-picker>
    </mat-form-field>

<!--    <mat-form-field appearance="outline" class="col-md-4">-->
<!--      <mat-label>Select Centre</mat-label>-->
<!--      <mat-select #selectElement [(ngModel)]="selectedCentreCode">-->
<!--        <mat-option value='All'> All Centres</mat-option>-->
<!--        <mat-option *ngFor=" let c of (centres$|async)  "          [value]="c.centreCode">{{ c.centreName }}-->
<!--        </mat-option>-->
<!--        &lt;!&ndash;      <mat-option  value="All">All Centres</mat-option>&ndash;&gt;-->
<!--      </mat-select>-->
<!--    </mat-form-field>-->

<!--    <app-searchable-select class="col-md-4"-->
<!--                           [(ngModel)]="selectedCentreCode"-->
<!--                           [options]="centres$ | async"-->
<!--                           [selectedValue]="selectedCentre"-->
<!--                           [displayWithFn]="displayCentre"-->
<!--                           [placeholder]="'Select Centre'"-->
<!--                           [label]="'Select Centre'"-->

<!--                           (selectionChange)="onCentreSelect($event)"-->
<!--    ></app-searchable-select>-->

    <app-searchable-select
      class="col-md-4"
      [options]="centres$ | async"
      [selectedValue]="selectedCentre"
      [displayWithFn]="displayCentre"
      [placeholder]="'Select Centre'"
      [label]="'Select Centre'"
      [multiple]="true"
      (selectionChange)="onCentreSelect($event)">
    </app-searchable-select>



    <button mat-mini-fab color="accent" (click)="search2()">
      <mat-icon>search</mat-icon>
    </button>
    <button class="mx-2" mat-mini-fab color="accent" (click)="Clear()">
      <mat-icon>clear</mat-icon>
    </button>

  </div>


  <div class="card p-2">
    <div class="ngxTableHeader">
      <ul class="header-buttons-left ms-0 mb-0">
        <li class="dropdown">
          <h2>Gender Count Report</h2>
        </li>
        <h5>This Table will give count of New and Followup Admission separately with N and F Notation </h5>
        <li class="dropdown m-l-20">
          <!--          <label for="search-input"><i class="material-icons search-icon">search</i></label>-->
          <!--          <input placeholder="Search" type="text" class="browser-default search-field"-->
          <!--                 (keyup)='applyFilter($event)' aria-label="Search box" #input>-->
        </li>
      </ul>
      <ul class="header-buttons mr-2">
        <!--      <li>-->
        <!--        <button   mat-mini-fab color="primary" (click)="openAddCarLog()">-->
        <!--          <mat-icon class="col-white" >add</mat-icon>-->
        <!--        </button>-->
        <!--      </li>-->
        <li>
          <div class="export-button m-l-10" matTooltip="XLSX" (click)="exportexcel()" permission="Gender Count Report" [permissionTypes]="[PermissionType.ALL, PermissionType.EXCEL]">
            <img src="assets/images/icons/xlsx.png" alt=""/>
          </div>
        </li>
      </ul>
    </div>

    <mat-progress-bar *ngIf="isLoading" mode="indeterminate">Please wait Data is loading... </mat-progress-bar>
    <table mat-table [dataSource]="dataSource" class="mat-elevation-z8" id="excel-table">

      <!-- Centre Name Column -->
      <ng-container matColumnDef="centreName">
        <th mat-header-cell *matHeaderCellDef> Centre Name</th>
        <td mat-cell *matCellDef="let element"> {{ element.centreName }}</td>
        <td mat-footer-cell *matFooterCellDef><strong>Total</strong> </td>

      </ng-container>

      <!-- Male Count Column -->
      <ng-container matColumnDef="maleCount">
        <th mat-header-cell *matHeaderCellDef> Male Count</th>
        <td mat-cell *matCellDef="let element"> {{ element.maleCount }}(N) {{ element.fMaleCount }}(F)</td>
        <td mat-footer-cell *matFooterCellDef="let element" >  {{ tmcount }}(N) {{tfmcount}}(F) <strong>Total</strong>: <strong>{{getTotal(tmcount,tfmcount)}}</strong> </td>

      </ng-container>

      <!-- Female Count Column -->
      <ng-container matColumnDef="femaleCount">
        <th mat-header-cell *matHeaderCellDef> Female Count</th>
        <td mat-cell *matCellDef="let element"> {{ element.femaleCount }}(N)  {{ element.fFemaleCount }}(F)</td>
        <td mat-footer-cell *matFooterCellDef="let element" >   {{tfcount}}(N)  {{tffcount}}(F) <strong>Total</strong>: <strong>{{getTotal(tfcount,tffcount)}}</strong></td>

      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      <tr mat-header-row *matFooterRowDef="displayedColumns"></tr>

    </table>

    <!--    <mat-paginator [pageSizeOptions]="[10, 25, 50, 100, 500]"></mat-paginator>-->
  </div>
  <hr>
  <div class="card p-2">
    <div class="ngxTableHeader">
      <ul class="header-buttons-left ms-0 mb-0">
        <li class="dropdown">
          <h2>Gender Count Report</h2>
          <h5>This Table will give count of New and Follow Up Combined </h5>
        </li>
        <li class="dropdown m-l-20">
          <!--          <label for="search-input"><i class="material-icons search-icon">search</i></label>-->
          <!--          <input placeholder="Search" type="text" class="browser-default search-field"-->
          <!--                 (keyup)='applyFilter($event)' aria-label="Search box" #input>-->
        </li>
      </ul>
      <ul class="header-buttons mr-2">
        <!--      <li>-->
        <!--        <button   mat-mini-fab color="primary" (click)="openAddCarLog()">-->
        <!--          <mat-icon class="col-white" >add</mat-icon>-->
        <!--        </button>-->
        <!--      </li>-->
        <li>
          <div class="export-button m-l-10" matTooltip="XLSX" (click)="exportexcel2()" permission="Gender Count Report" [permissionTypes]="[PermissionType.ALL, PermissionType.EXCEL]">
            <img src="assets/images/icons/xlsx.png" alt=""/>
          </div>
        </li>
      </ul>
    </div>

    <mat-progress-bar *ngIf="isLoading" mode="indeterminate">Please wait Data is loading... </mat-progress-bar>
    <table mat-table [dataSource]="dataSource2" class="mat-elevation-z8" id="excel-table2">

      <!-- Centre Name Column -->
      <ng-container matColumnDef="centreName">
        <th mat-header-cell *matHeaderCellDef> Centre Name</th>
        <td mat-cell *matCellDef="let element"> {{ element.centreName }}</td>
        <td mat-footer-cell *matFooterCellDef><strong>Total</strong> </td>

      </ng-container>

      <!-- Male Count Column -->
      <ng-container matColumnDef="maleCount">
        <th mat-header-cell *matHeaderCellDef> Male Count</th>
        <td mat-cell *matCellDef="let element"> {{ element.maleCount+element.fMaleCount }} </td>
        <td mat-footer-cell *matFooterCellDef="let element" ><strong> {{ tmcount+tfmcount }} </strong>  </td>

      </ng-container>

      <!-- Female Count Column -->
      <ng-container matColumnDef="femaleCount">
        <th mat-header-cell *matHeaderCellDef> Female Count</th>
        <td mat-cell *matCellDef="let element"> {{ element.femaleCount + element.fFemaleCount }}</td>
        <td mat-footer-cell *matFooterCellDef="let element" ><strong> {{tfcount+tffcount}} </strong> </td>

      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns2"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns2;"></tr>
      <tr mat-header-row *matFooterRowDef="displayedColumns2"></tr>

    </table>

    <!--    <mat-paginator [pageSizeOptions]="[10, 25, 50, 100, 500]"></mat-paginator>-->
  </div>






</div>
